import React, { Fragment } from 'react';
import { useIntl } from 'react-intl';

import NotFoundData from '@/components/Base/NotFoundData';
import ProductCardLoader from '@/components/Pages/Home/ProductCardLoader';
import ProductCard from '@/components/Pages/Home/ProductCardWrapper';
import ProductsListHeader from '@/components/Pages/Home/ProductsListHeader';
import { useGetProductsWithCompany, usePageProps } from '@/hooks';

import { List } from './ProductsList.styles';

function ProductsList() {
  const { params } = usePageProps();
  const { locale } = useIntl();
  const { products, count, isFetching } = useGetProductsWithCompany({
    locale,
  });
  const isRvkPage = params.companySlug && !params.productId;

  return (
    <>
      {products?.length && <ProductsListHeader count={count} />}

      <List id="mc-products-list">
        {!isFetching ? (
          products?.map((product) => (
            <ProductCard key={product.id} {...product} isRvkPage={isRvkPage} />
          ))
        ) : (
          <ProductCardLoader />
        )}

        {!products?.length && !isFetching && <NotFoundData />}
      </List>
    </>
  );
}

export default ProductsList;
